export const CONSENT_TEXT =
  'By continuing to browse this site, you are agreeing to the use of cookies, whose purpose it is to provide web analytics and measurements of visitor traffic and browsing behavior.';
export const ACCEPT_LABEL = 'I agree';
export const ARIA_ACCEPT_LABEL = 'Accept cookies usages';
